import './header.css';

export default function Header() {
    return (
        <div className="header">
            <h1 className="header-title">Prijemni Ispiti Hemija</h1>
            <nav className="nav-bar">
                <ul className="nav-bar-list">
                    <li><a href="#main-info">INFO</a></li>
                    <li><a href="#pricelist">CENOVNIK</a></li>
                    <li><a href="#material">MATERIJALI</a></li>
                    <li><a href="#contact">KONTAKT</a></li>
                </ul>
            </nav>
        </div>
    );
}